/**
 * Project Gallery block: open popover from grid image clicks or from the global
 * "Sign Gallery" button (data-gallery-modal), and scroll to the selected image.
 */
(function () {
  const prefersReducedMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)",
  ).matches;

  function openGalleryAt(popover, index) {
    if (!popover || typeof popover.showPopover !== "function") return;
    popover.showPopover();

    requestAnimationFrame(function () {
      const item = popover.querySelector(
        '[data-gallery-item-index="' + String(index) + '"]',
      );
      if (item) {
        item.scrollIntoView({
          behavior: prefersReducedMotion ? "auto" : "smooth",
          block: "center",
        });
      }
    });
  }

  function init() {
    const galleryBlocks = document.querySelectorAll(".project-gallery");
    const firstPopover = document.querySelector(
      "[data-project-gallery-popover]",
    );

    galleryBlocks.forEach(function (block) {
      const popover = block.parentElement.querySelector(
        "[data-project-gallery-popover]",
      );

      if (!popover) return;

      block
        .querySelectorAll("[data-gallery-open-index]")
        .forEach(function (trigger) {
          const index = trigger.getAttribute("data-gallery-open-index");
          if (index === null) return;
          trigger.addEventListener("click", function (e) {
            e.preventDefault();
            openGalleryAt(popover, index);
          });
        });
    });

    document.querySelectorAll("[data-gallery-modal]").forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        if (!firstPopover) return;
        e.preventDefault();
        openGalleryAt(firstPopover, 0);
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
